export default __webpack_public_path__ + "static/media/Firefox.372a5c64.svg";